import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import './follow-up-actions-contracts-contract.view.css'
import {
    ButtonHLPure,
    SimpleLoading
} from "../../pures";



const FollowUpActionsContractsContractView = (props) => {
    const { contract, setShowDetails, setNameComponentUser, loading } = props

    const { t } = useTranslation()

    const [urlPdf, setUrlPdf] = useState("")
    const pdf = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])

    useEffect(() => {
        if (contract) {
            let url = contract.updatedDocumentPathPdf !== '' ? contract.updatedDocumentPathPdf : contract.originalDocumentPathPdf
            setUrlPdf(url)
        }
    }, [contract])



    const handleClickBack = () => {
        setShowDetails(false);
        setNameComponentUser("")
    }

    return (
        <div className="">
            {loading ? (
                <SimpleLoading />
            ) : (
                <div>
                    <div className="followUpActionsContractsContractView-template-container">
                        {pdf}
                    </div>
                    <div className="followUpActionsContractsContractView-btn">
                        <ButtonHLPure
                            nameBtn={t('button.return')}
                            primary={true}
                            onClickBtn={handleClickBack}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default FollowUpActionsContractsContractView;
